import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "@/components/Reveal";

const IMG =
  "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="about"
      ref={ref}
      className="relative py-24 sm:py-32 lg:py-40 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16"
      data-testid="about-section"
    >
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div className="relative overflow-hidden rounded-[2px] aspect-[4/5]">
              <motion.img
                style={{ y }}
                src={IMG}
                alt="Wedding details"
                className="w-full h-[115%] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:right-6 bg-[var(--bg)] border border-[var(--border-gold)] px-7 py-5 rounded-[2px] shadow-[0_20px_60px_-30px_rgba(35,31,32,0.5)]">
              <div className="font-serif text-4xl text-[var(--gold)]">250+</div>
              <div className="text-xs tracking-wide text-[var(--ink-2)]">Celebrations crafted</div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <Overline testid="about-overline">Our Philosophy</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-2xl">
              We believe a wedding is a <span className="italic text-[var(--gold)]">living story</span>,
              not an event.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base sm:text-lg text-[var(--ink-2)] font-light leading-relaxed max-w-xl">
              Weddings by Temple Bells began with a simple conviction — that the most sacred day of
              your life deserves the devotion of true artisans. We blend time-honoured ritual with
              editorial design, orchestrating every element so you can simply be present.
            </p>
          </Reveal>

          <div className="mt-12 grid sm:grid-cols-3 gap-8">
            {[
              { k: "12+", v: "Years of craft" },
              { k: "40+", v: "Destinations" },
              { k: "100%", v: "Bespoke design" },
            ].map((s, i) => (
              <Reveal key={s.v} delay={0.1 * i}>
                <div className="border-l border-[var(--border-gold)] pl-5">
                  <div className="font-serif text-3xl text-[var(--ink)]">{s.k}</div>
                  <div className="text-sm text-[var(--ink-3)] mt-1">{s.v}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
